const AUTH_TOKEN = 'authToken';
const USER_TOKEN = 'userToken';

export const getToken = () => sessionStorage.getItem(USER_TOKEN) || localStorage.getItem(AUTH_TOKEN) || '';
export const isAdminLogged = () =>
    sessionStorage.getItem(USER_TOKEN) && sessionStorage.getItem(USER_TOKEN) !== localStorage.getItem(AUTH_TOKEN);
